import type { ThemeDefinition } from "vuetify";

const theme: ThemeDefinition = {
  colors: {
    primary: "#319874",
    "primary-100": "#D9F2E5",
    "primary-300": "#86CFB1",
    "primary-400": "#53B48E",
    "primary-600": "#22795C",
    "primary-800": "#195241",
    secondary: "#E5B88A",
    "secondary-700": "#cc8547",
    "secondary-500": "#E5B88A",
    "secondary-900": "#592D00",
    neutral: "#656e89",
    "neutral-100": "#ECEDF2",
    "neutral-200": "#D6D8E1",
    "neutral-300": "#B2B7C7",
    "neutral-400": "#8890A8",
    "neutral-500": "#656E89",
    "neutral-700": "#454b5f",
    "neutral-800": "#3B3F51",
    info: "#297fff",
    "info-100": "#EDF6FF",
    "info-400": "#51A3FF",
    success: "#30b73b",
    "success-100": "#DFF9E0",
    "success-500": "#30B73B",
    "success-600": "#22972B",
    "success-700": "#218229",
    "success-800": "#1d5e23",
    error: "#e54e4e",
    "error-100": "#fce4e4",
    "error-800": "#912323",
    warning: "#eab308",
    "warning-100": "#FEF0C3",
    "warning-800": "#cc8547",
    tertiary: "#E74C53",
    "tertiary-700": "#B11E30",
  },
};
export default theme;
